/* Scope to the confirmed broken Rivo release; later releases use their original asset. */
(function () {
  var script = document.currentScript;
  var replacement = script && script.dataset.referralsAsset;
  function apply() {
    var assets = window.Rivo && window.Rivo.global_config && window.Rivo.global_config.asset_urls;
    var loy = assets && assets.loy;
    if (!loy || !replacement) return;
    if (String(loy.referrals_js).indexOf('/rivo-loyalty-rewards-referrals-822/assets/ba_loy_referrals.js') !== -1) {
      loy.referrals_js = replacement;
    }
  }
  apply();
  document.addEventListener('DOMContentLoaded', apply, {once:true});
})();
